import Vue from "vue";
import { debounce } from 'lodash';

Vue.component("objection-autocomplete", {
    props: ["value",
        "language",
        "disabled"
    ],
    data() {
        return {
            isFetching: false,
            data: [],
            selected: null,
            myValue: null,
            isDisabled: this.disabled
        };
    },
    watch: {
        selected: function (val) {
            if (val) {
                if (val.id != this.value) {
                    this.$emit("update:value", val.id);

                }

                //this.myValue = val.notifyingPartyReference;
            }
        }
    },
    methods: {
        getAsyncData: debounce(function (query) {
            if (!query.length) {
                this.data = []
                return
            }

            this.isFetching = true;

            this.$services.objectionNotificationService.getAutocomplete({
                language: this.language,
                query: query
            })
                .then((data) => {
                    this.data = []
                    if (data.items) {
                        data.items.forEach((item) => this.data.push(item))
                    }
                    this.isFetching = false;
                });
        }, 500)
    },
    mounted() {
        if (this.value) {


            this.$services.objectionNotificationService.getAutocomplete({
                language: this.language,
                id: this.value
            })
                .then((data) => {
                    this.data = []
                    if (data.items) {


                        data.items.forEach((item) => this.data.push(item))

                        this.myValue = data.items[0].documentSymbol;
                    }

                });
        } else {
            this.$services.objectionNotificationService.getAutocomplete({
                language: this.language
            })
                .then((data) => {
                    this.data = []
                    if (data.items) {
                        data.items.forEach((item) => this.data.push(item))
                    }
                    //this.isFetching = false;

                });
        }
    },
    template: `
		<div>
			<b-autocomplete
                v-model="myValue"
                :data="data"
                placeholder="e.g. Title/Introduction/Notifying Party Reference"
                field="documentSymbol"
                :loading="isFetching"
                @typing="getAsyncData"
                clearable
                :disabled="isDisabled"
                open-on-focus 
                @select="option => selected = option"
                >

                <template slot-scope="props">
                    <div class="media">
                      
	                    <div class="media-content">
		                    {{ props.option.documentSymbol }}
		                    <br>
			                    <small>
				                    Title:{{ props.option.title }}<br />
				                    Party:{{ props.option.countryName }}
			                    </small>
	                    </div>
                    </div>
                </template>
            </b-autocomplete>
		</div>
	`
});